import axios from 'axios';

class ApiServiceClass{
    constructor(){
        this.url = 'https://plameet.com';
        this.apiUrl = 'https://plameet.com/api/v1';
    }

    createTag({onSucess=null, onError=null, tagData=null}){
        axios.post(`${this.apiUrl}/tags`,
            {tag: tagData},
            { crossdomain: true, headers: {} }
        ).then(onSucess).catch(onError);
    }
    tagsAutocomplete({onSucess=null, onError=null, term=null}){
        axios.get(`${this.apiUrl}/tags/autocomplete?term=${term}`,
            { crossdomain: true, headers: {} }
        ).then(onSucess).catch(onError);
    }
    createTask({onSucess=null, onError=null, taskData=null}){
        axios.post(`${this.apiUrl}/tasks`, 
            {task: taskData},
            {crossdomain: true, headers: {}}
        ).then(onSucess).catch(onError)
    }
    timesUpTask({onSucess=null, onError=null, taskId=null}){
        axios.patch(`${this.apiUrl}/tasks/${taskId}/times_up`, 
            {crossdomain: true, headers: {}}
        ).then(onSucess).catch(onError)
    }
    listInstanceTask({onSucess=null, onError=null, date=null}){
        axios.get(`${this.apiUrl}/tasks/list_instances?date=${JSON.stringify(date)}`,
            {crossdomain: true, headers: {}}
        ).then(onSucess).catch(onError)
    }
    deleteTask({onSucess=null, onError=null, taskId=null}){
        axios.delete(`${this.apiUrl}/tasks/${taskId}`, 
            {crossdomain: true, headers: {}}
        ).then(onSucess).catch(onError)
    }
}

export const ApiService = new ApiServiceClass();
